/**
* DecisionContent.js
* 
* Created on Oct 8, 2013, 11:26:22 AM
*
* @author Javier Quevedo-Fernandez for Ranj
**/

import Content from "./Content";

export default class DecisionContent extends Content {

    constructor(languagePack, contentID, decisionDialog, decisionTitle, label) {
        super(DecisionContent.NAME, DecisionContent.TYPE, label, languagePack, contentID);
        this._decisionDialog = decisionDialog;
        this._decisionTitle = decisionTitle;
    }

    getDecisionTitle() {
        return this._decisionTitle;
    }
    setDecisionTitle(value) {
        if (this._decisionTitle !== value) {
            this._decisionTitle = value;
        }
    }
    getDecisionDialogID() {
        return this._decisionDialog;
    }
    getDialogID() {
        return this._decisionDialog;
    }
    setDecisionDialogID(value) {
        if (this._decisionDialog !== value) {
            this._decisionDialog = value;
        }
    }
    clone(value) {
        var clone = new DecisionContent(this._languagePack, null, null, null, this.getLabel());
        clone.setContentID(this.getContentID());
        clone.setDecisionDialogID(this.getDecisionDialogID());
        clone.setDecisionTitle(this.getDecisionTitle());
        return clone;
    }
    remove() {
        this.setDecisionDialogID(null);
        this.setDecisionTitle(null);
        super.remove();
    }
    convertToObject() {
        return this.getObject(["decisionDialogID", "decisionTitle"]);
    }
}

DecisionContent.NAME = "Decision";
DecisionContent.TYPE = "engDecisionContent";






